/**
 * @author Ariel
 * @date 2020-09-01
 * @desc 栏目应用查看
 */
import React from "react";
import { connect } from 'dva';
import { Descriptions } from 'antd';
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { WizAuthority } from "../../../common";

let { WizContainer, modelUtils, ossFileUtils } = framework_tool
let { WizCard, WizSelect, WizTag, WizCol } = component_tool
let { Session } = utils_tool

class ApplicationColumnLook extends WizContainer {
  componentName = 'applicationColumnLook'

  constructor(props) {
    super(props)
    const { history } = props
    let detailInfo = {};
    if (history.location && history.location.pathname === '/application/applicationColumn/applicationColumnLook') {
      if (history.location && history.location.record) {
        detailInfo = history.location.record
        Session.set('detailInfo', detailInfo)
      } else {
        detailInfo = Session.get('detailInfo') || {}
      }
    }
    this.detailInfo = detailInfo
  }

  _componentDidMount() {
  }

  authorityInfo = () => {
    return (
      <WizAuthority value={this.detailInfo.authInfo} mode='Show' showBlock={false} />
    )
  }

  getImgInfo = () => {
    let record = this.detailInfo
    let url = getOssFilePath(record.img)
    // ossFileUtils.getOssFile(
    //   record.img,
    //   record.fileName,
    //   record.fileMimeType,
    //   record.fileSize,
    //   record.fileUri,
    // ).url
    url = record.img ? url : constants.files.sys_img_loadingFailed;
    return <div style={{ display: 'flex', 'justify-content': 'flex-start', marginRight: 0, }}>
      <div>
        <img height={50} width={50} src={url} />
      </div>
    </div>
  }

  getRoleNames = (roleNames) => {
    if (roleNames && roleNames.length) {
      return (
        <WizCol>
          {roleNames.map((role) => {
            return <WizTag>{role}</WizTag>
          })}
        </WizCol>
      )
    } else {
      return (
        <WizCol />)
    }

  }

  _render() {
    const items = this.detailInfo
    items['type'] == 0 ? items['type'] = "独立应用" : items['type'] == 1 ? items['type'] = "内嵌应用" : items['type'] = "外链"
    items['status'] == 0 ? items['status'] = "禁用" : items['status'] = "启用"
    let roleNames = []
    items['roleNames'] && items['roleNames'].split(",").map(d => {
      let id = d.substring(0, d.indexOf('-') + 1)
      let name = d.replace(id, '')
      return roleNames.push(name)
    })

    return (
      <React.Fragment>
        <WizCard>
          <Descriptions column={1} style={{ paddingLeft: 25 }} bordered={true}>
            <Descriptions.Item label='应用名称'>{items.name}</Descriptions.Item>
            <Descriptions.Item label='所属服务'>{items.applicationName}</Descriptions.Item>
            <Descriptions.Item label='封面'>{this.getImgInfo()}</Descriptions.Item>
            <Descriptions.Item label='URL(PC)'>{items.url}</Descriptions.Item>
            <Descriptions.Item label='URL(APP)'>{items.appUrl}</Descriptions.Item>
            <Descriptions.Item label='URL(企业微信)'>{items.busWxUrl}</Descriptions.Item>
            <Descriptions.Item label='分类'>{items.categoryName}</Descriptions.Item>
            <Descriptions.Item label='类型'>{items.type}</Descriptions.Item>
            <Descriptions.Item label='受众'>{this.authorityInfo()}</Descriptions.Item>
            <Descriptions.Item label='角色'>{this.getRoleNames(roleNames)}</Descriptions.Item>
            <Descriptions.Item label='适用终端'>{items.adapterNames}</Descriptions.Item>
            <Descriptions.Item label='状态'>{items.status}</Descriptions.Item>
          </Descriptions>
        </WizCard>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const load = modelUtils.getLoadingState(state, 'applicationColumn')
  return {
    ...load
  }
};

export default connect(mapStateToProps)(ApplicationColumnLook)

